(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wnbc-announcement"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAll(scope){
  var bars = (scope || document).querySelectorAll('[data-wnbc-ann]');
  if (!bars.length) return;

  function hashText(str) {
    /* djb2 — tiny stable hash so the dismissal key changes when the copy changes */
    var h = 5381;
    for (var i = 0; i < str.length; i++) {
      h = ((h << 5) + h + str.charCodeAt(i)) | 0;
    }
    return (h >>> 0).toString(36);
  }

  function storageGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function storageSet(key, val) {
    try { window.sessionStorage.setItem(key, val); } catch (e) { /* private mode — dismiss lasts for the page only */ }
  }

  var designMode = window.Shopify && window.Shopify.designMode;

  Array.prototype.forEach.call(bars, function (bar) {
    if (bar.dataset.wnbcAnnReady === 'true') return;
    bar.dataset.wnbcAnnReady = 'true';
    var track = bar.querySelector('.wnbc-ann-track');
    var text = track ? (track.textContent || '').replace(/\s+/g, ' ').trim() : '';
    var key = 'wnbc-ann:' + (bar.getAttribute('data-section-id') || '') + ':' + hashText(text);
    var dismissible = bar.getAttribute('data-dismissible') === 'true';

    /* Hide before first paint if already dismissed this session.
       (Skipped in the theme editor so staff always see the bar.) */
    if (dismissible && !designMode && storageGet(key) === '1') {
      bar.setAttribute('hidden', 'hidden');
      return;
    }

    var dismissBtn = bar.querySelector('[data-wnbc-ann-dismiss]');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        storageSet(key, '1');
        bar.setAttribute('hidden', 'hidden');
      });
    }

    /* Rotation — only with 2+ messages and no reduced-motion preference */
    var msgs = bar.querySelectorAll('.wnbc-ann-msg');
    if (msgs.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var secs = parseInt(bar.getAttribute('data-rotate-secs'), 10);
    if (!secs || secs < 2) secs = 5;
    var current = 0;
    var paused = false;

    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });

    setInterval(function () {
      if (paused || bar.hasAttribute('hidden')) return;
      msgs[current].classList.remove('wnbc-ann-msg--active');
      msgs[current].setAttribute('aria-hidden', 'true');
      current = (current + 1) % msgs.length;
      msgs[current].classList.add('wnbc-ann-msg--active');
      msgs[current].removeAttribute('aria-hidden');
    }, secs * 1000);
  });
}

  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wnbc-featured-grid"] && !Shopify.designMode) return;
  try {
    
/* Quantity steppers for the featured grid buy rows. Delegated on document so
   theme-editor re-renders never need re-binding. MOQ = the input's min. */
(function () {
  if (window.wnbcFgSteppersReady) return;
  window.wnbcFgSteppersReady = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fg-dec], [data-fg-inc]');
    if (!btn) return;
    var wrap = btn.closest('.wnbc-fg-qty');
    var input = wrap && wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var val = parseInt(input.value, 10) || min;
    if (btn.hasAttribute('data-fg-dec')) val = Math.max(min, val - 1);
    else val = val + 1;
    input.value = val;
  });
})();

/* AJAX add-to-cart for the buy rows. The theme (Sleek/FoxTheme) uses a cart
   DRAWER everywhere, so a native /cart/add navigation would eject the buyer
   to /cart after every single add. Instead: POST the form via fetch, publish
   the theme's cartUpdate pubsub event (refreshes drawer contents + the
   <cart-count> bubble) and open <cart-drawer>. If anything goes wrong we fall
   back to the native form submit so an add can never silently fail.
   Listeners are delegated on document and guarded by a window flag, so
   'shopify:section:load' re-renders never double-bind. */
(function () {
  function wnbcFgBindAjaxAdd() {
    if (window.wnbcFgAjaxAddReady) return;
    window.wnbcFgAjaxAddReady = true;

    function updateCountFallback(cart) {
      var els = document.querySelectorAll('cart-count, [data-cart-count], .cart-count-bubble');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', cart.item_count);
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      }
    }

    function flashAdded(button) {
      if (!button || button.dataset.wnbcFgFlashing) return;
      button.dataset.wnbcFgFlashing = 'true';
      var label = button.textContent;
      button.textContent = 'Added ✓';
      button.classList.add('is-added');
      window.setTimeout(function () {
        button.textContent = label;
        button.classList.remove('is-added');
        delete button.dataset.wnbcFgFlashing;
      }, 2000);
    }

    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest && e.target.closest('form[data-wnbc-fg-form]');
      if (!form) return;
      if (!window.fetch || !window.FormData) return; /* let the native submit run */
      e.preventDefault();

      var button = form.querySelector('.wnbc-fg-add');
      if (button && button.hasAttribute('aria-disabled')) return;

      /* Same section-bundling handshake the theme's own product-form uses:
         cart-drawer pushes its section id so /cart/add returns its HTML. */
      var sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
      );

      var fd = new FormData(form); /* sends the qty input's value; min/step (MOQ) live on the input */
      fd.append('sections', sections);
      fd.append('sections_url', window.location.pathname);

      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('btn--loading');
      }

      var routes = (window.FoxTheme && window.FoxTheme.routes) || {};

      fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd
      })
        .then(function (response) { return response.json(); })
        .then(function (added) {
          if (added.status) throw new Error(added.description || 'Add to cart failed');
          return fetch(routes.cart_url || '/cart.js', {
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
          })
            .then(function (response) { return response.json(); })
            .then(function (cart) {
              cart.sections = added.sections;

              var pubsub = window.FoxTheme && window.FoxTheme.pubsub;
              if (pubsub && pubsub.PUB_SUB_EVENTS && pubsub.PUB_SUB_EVENTS.cartUpdate) {
                /* Refreshes drawer body/footer AND the <cart-count> bubble. */
                pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
              } else {
                updateCountFallback(cart);
              }

              var drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.show === 'function') {
                drawer.show(button);
              } else {
                flashAdded(button);
              }
            });
        })
        .catch(function () {
          /* Network error, malformed response or cart error: never fail
             silently — hand off to the native form submit (navigates). */
          form.submit();
        })
        .finally(function () {
          if (button) {
            button.classList.remove('btn--loading');
            button.removeAttribute('aria-disabled');
          }
        });
    });
  }

  wnbcFgBindAjaxAdd();
  document.addEventListener('shopify:section:load', wnbcFgBindAjaxAdd);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wnbc-margin-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCalc(root) {
    if (!root || root.dataset.wnbcCalcReady === '1') return;
    var sel = root.querySelector('[data-calc-product]');
    var qty = root.querySelector('[data-calc-qty]');
    var price = root.querySelector('[data-calc-price]');
    var tierField = root.querySelector('[data-calc-tier]');
    var outCost = root.querySelector('[data-calc-cost]');
    var outRev = root.querySelector('[data-calc-rev]');
    var outProfit = root.querySelector('[data-calc-profit]');
    if (!sel || !qty || !price || !tierField || !outCost || !outRev || !outProfit) return;
    root.dataset.wnbcCalcReady = '1';

    var fmt;
    try {
      fmt = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: root.dataset.currency || 'USD'
      });
    } catch (e) {
      fmt = { format: function (n) { return '$' + n.toFixed(2); } };
    }

    function run() {
      /* Whole-pack math from REAL variant prices — matches checkout exactly.
         packSize comes from the variant title ("12pc" = 12); loose units = 1. */
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      var packPrice = (parseFloat(opt.value) || 0) / 100; /* variant price, cents */
      var packSize = Math.max(1, parseInt(opt.dataset.units, 10) || 1);
      var q = Math.max(1, parseInt(qty.value, 10) || 1);
      var packs = Math.ceil(q / packSize);
      var unitsBought = packs * packSize;
      var cost = packs * packPrice;
      var revenue = (parseFloat(price.value) || 0) * unitsBought;
      var profit = revenue - cost;

      tierField.value = packSize > 1
        ? packs + ' × ' + packSize + '-pack — ' + fmt.format(packPrice / packSize) + '/unit (' + unitsBought + ' units)'
        : q + ' single units — ' + fmt.format(packPrice) + '/unit';
      outCost.textContent = fmt.format(cost);
      outRev.textContent = fmt.format(revenue);
      outProfit.textContent = fmt.format(profit);
    }

    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var msrp = opt ? parseFloat(opt.dataset.msrp) : 0;
      if (msrp > 0) price.value = msrp;
      run();
    });
    qty.addEventListener('input', run);
    price.addEventListener('input', run);

    /* Prefill retail from the first option's MSRP, if set. */
    var first = sel.options[sel.selectedIndex];
    if (first && parseFloat(first.dataset.msrp) > 0) price.value = parseFloat(first.dataset.msrp);
    run();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wnbc-calc]').forEach(initCalc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: re-init when a section is (re)loaded. */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wnbc-quick-order"] && !Shopify.designMode) return;
  try {
    
/* WNBC quick order pad — live Shopify endpoints, no libraries.
   Defensive by design: every fetch is wrapped, every failure is shown to the
   buyer inline, and nothing is added to the cart without a resolved variant. */
(function () {
  'use strict';

  var DEBOUNCE_MS = 250;

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function initPad(root) {
    if (!root || root.dataset.wnbcQoReady === 'true') return;
    root.dataset.wnbcQoReady = 'true';

    var cfg = {
      moneyFormat: root.dataset.moneyFormat || ('$' + '{' + '{amount}' + '}'),
      searchPlaceholder: root.dataset.labelSearchPlaceholder || '',
      qtyLabel: root.dataset.labelQty || 'Qty',
      removeLabel: root.dataset.labelRemove || 'Remove line',
      noMatch: root.dataset.textNoMatch || 'No matching product.',
      noMatchTip: root.dataset.textNoMatchTip || '',
      loading: root.dataset.textLoading || 'Checking price…',
      unavailable: root.dataset.textUnavailable || 'Currently unavailable.',
      errEmpty: root.dataset.errorEmpty || 'Nothing to add yet.',
      errNetwork: root.dataset.errorNetwork || 'Connection problem. Please try again.',
      errCart: root.dataset.errorCart || 'The cart rejected that order. Please try again.',
      errUnmatched: root.dataset.errorUnmatched || 'No match for',
      errPasteEmpty: root.dataset.errorPasteEmpty || 'Paste at least one line first.'
    };
    // Full "no match" message: base text plus the returning-buyer tip, if set.
    cfg.noMatchFull = cfg.noMatchTip ? cfg.noMatch + ' ' + cfg.noMatchTip : cfg.noMatch;

    var rowsHost = root.querySelector('[data-wnbc-qo-rows]');
    var template = root.querySelector('template[data-wnbc-qo-row]');
    var totalEl = root.querySelector('[data-wnbc-qo-total]');
    var errorEl = root.querySelector('[data-wnbc-qo-error]');
    var addAllBtn = root.querySelector('[data-wnbc-qo-add-all]');
    var addLineBtn = root.querySelector('[data-wnbc-qo-add-line]');
    var pasteArea = root.querySelector('[data-wnbc-qo-paste]');
    var parseBtn = root.querySelector('[data-wnbc-qo-parse]');
    if (!rowsHost || !template || !totalEl || !addAllBtn) return;

    var lines = [];
    var lineSeq = 0;
    var productCache = {}; // handle → product json (or in-flight promise)

    /* ---------- money ---------- */

    function formatMoney(cents) {
      var value = Math.round(cents) / 100;
      // money_format can carry HTML (e.g. <span class=money>${{amount}}</span>);
      // totals are written via textContent, so strip tags or they'd show literally.
      var format = (cfg.moneyFormat || '').replace(/<[^>]+>/g, '');
      var num;
      try {
        if (format.indexOf('amount_no_decimals') !== -1) {
          num = String(Math.round(value));
        } else if (format.indexOf('amount_with_comma_separator') !== -1) {
          num = value.toFixed(2).replace('.', ',');
        } else {
          num = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, num);
      } catch (e) {
        return '$' + value.toFixed(2);
      }
    }

    /* ---------- inline errors ---------- */

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }
    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    /* ---------- live endpoints ---------- */

    async function searchProducts(term) {
      var url = routeRoot() + 'search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[options][fields]=title,variants.sku';
      var res = await fetch(url, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('suggest ' + res.status);
      var data = await res.json();
      return (data && data.resources && data.resources.results && data.resources.results.products) || [];
    }

    function fetchProduct(handle) {
      if (!productCache[handle]) {
        productCache[handle] = fetch(routeRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
          headers: { 'Accept': 'application/json' }
        }).then(function (res) {
          if (!res.ok) throw new Error('product ' + res.status);
          return res.json();
        }).catch(function (err) {
          delete productCache[handle]; // don't cache failures
          throw err;
        });
      }
      return productCache[handle];
    }

    /* ---------- totals ---------- */

    function lineQty(line) {
      var q = parseInt(line.qtyInput.value, 10);
      return isNaN(q) || q < 1 ? 0 : q;
    }

    function updateTotals() {
      var sum = 0;
      var any = false;
      lines.forEach(function (line) {
        var q = lineQty(line);
        if (line.variant && q >= 1) {
          var cents = line.variant.price * q; // price is in cents
          line.lineEl.textContent = formatMoney(cents);
          sum += cents;
          any = true;
        } else {
          line.lineEl.textContent = '—';
        }
      });
      totalEl.textContent = any ? formatMoney(sum) : '—';
    }

    /* ---------- row status helpers ---------- */

    function setStatus(line, text, kind) {
      line.statusEl.textContent = text || '';
      line.statusEl.classList.toggle('wnbc-qo-status--ok', kind === 'ok');
      line.statusEl.classList.toggle('wnbc-qo-status--warn', kind === 'warn');
    }

    function closeSuggest(line) {
      line.suggestEl.hidden = true;
      line.suggestEl.innerHTML = '';
    }

    /* ---------- variant resolution ---------- */

    function pickVariant(product, targetSku) {
      var variants = (product && product.variants) || [];
      if (!variants.length) return null;
      if (targetSku) {
        var want = String(targetSku).trim().toLowerCase();
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].sku || '').trim().toLowerCase() === want) return variants[i];
        }
        return null; // exact SKU requested — never guess
      }
      for (var j = 0; j < variants.length; j++) {
        if (variants[j].available) return variants[j];
      }
      return variants[0];
    }

    async function selectProduct(line, handle, targetSku) {
      var token = ++line.resolveToken;
      line.variant = null;
      setStatus(line, cfg.loading, null);
      updateTotals();
      try {
        var product = await fetchProduct(handle);
        if (token !== line.resolveToken) return false;
        var v = pickVariant(product, targetSku);
        if (!v) {
          setStatus(line, cfg.noMatch, 'warn');
          updateTotals();
          return false;
        }
        if (!v.available) {
          setStatus(line, (product.title || '') + ' · ' + cfg.unavailable, 'warn');
          updateTotals();
          return false;
        }
        line.variant = { id: v.id, price: v.price, title: product.title, sku: v.sku || '' };
        if (!line.qtyInput.value || lineQty(line) < 1) line.qtyInput.value = '1';
        var label = product.title + ' · ' + formatMoney(v.price);
        if (v.sku) label = v.sku + ' · ' + label;
        setStatus(line, label, 'ok');
        updateTotals();
        return true;
      } catch (e) {
        if (token === line.resolveToken) {
          setStatus(line, cfg.errNetwork, 'warn');
          updateTotals();
        }
        return false;
      }
    }

    /* ---------- search-as-you-type ---------- */

    function renderSuggestions(line, products) {
      closeSuggest(line);
      if (!products.length) {
        setStatus(line, cfg.noMatchFull, 'warn');
        return;
      }
      products.slice(0, 5).forEach(function (p) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wnbc-qo-suggest-item';
        btn.textContent = p.title;
        btn.addEventListener('click', function () {
          line.searchInput.value = p.title;
          closeSuggest(line);
          selectProduct(line, p.handle, null);
        });
        line.suggestEl.appendChild(btn);
      });
      line.suggestEl.hidden = false;
    }

    async function runSearch(line) {
      var term = line.searchInput.value.trim();
      if (!term) { closeSuggest(line); setStatus(line, '', null); return; }
      var token = ++line.searchToken;
      try {
        var products = await searchProducts(term);
        if (token !== line.searchToken) return; // a newer keystroke won
        renderSuggestions(line, products);
      } catch (e) {
        if (token === line.searchToken) setStatus(line, cfg.errNetwork, 'warn');
      }
    }

    /* ---------- rows ---------- */

    function createLine(prefill) {
      var frag = template.content.cloneNode(true);
      var el = frag.querySelector('.wnbc-qo-row');
      var n = ++lineSeq;

      var line = {
        el: el,
        searchInput: el.querySelector('.wnbc-qo-search'),
        suggestEl: el.querySelector('.wnbc-qo-suggest'),
        statusEl: el.querySelector('.wnbc-qo-status'),
        qtyInput: el.querySelector('.wnbc-qo-qty'),
        lineEl: el.querySelector('.wnbc-qo-line'),
        removeBtn: el.querySelector('.wnbc-qo-x'),
        variant: null,
        searchToken: 0,
        resolveToken: 0,
        debounceTimer: null
      };

      line.searchInput.placeholder = cfg.searchPlaceholder;
      line.searchInput.setAttribute('aria-label', cfg.searchPlaceholder + ' — ' + n);
      line.qtyInput.setAttribute('aria-label', cfg.qtyLabel + ' — ' + n);
      line.removeBtn.setAttribute('aria-label', cfg.removeLabel + ' — ' + n);

      line.searchInput.addEventListener('input', function () {
        line.variant = null;           // typing invalidates the resolved product
        line.resolveToken++;
        setStatus(line, '', null);
        updateTotals();
        clearTimeout(line.debounceTimer);
        line.debounceTimer = setTimeout(function () { runSearch(line); }, DEBOUNCE_MS);
      });

      line.searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeSuggest(line);
      });

      line.qtyInput.addEventListener('input', updateTotals);
      // Returning-buyer flow: Enter in a qty field jumps to the next row's
      // search input (creating a row if this is the last one). Additive only —
      // there is no surrounding <form>, so Enter had no behaviour to lose.
      line.qtyInput.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        var idx = lines.indexOf(line);
        var next = lines[idx + 1] || createLine(null);
        if (next && next.searchInput) next.searchInput.focus();
      });
      line.qtyInput.addEventListener('blur', function () {
        if (line.qtyInput.value !== '' && lineQty(line) < 1) line.qtyInput.value = '1';
        updateTotals();
      });

      line.removeBtn.addEventListener('click', function () {
        var idx = lines.indexOf(line);
        if (idx > -1) lines.splice(idx, 1);
        el.remove();
        if (!lines.length) createLine(null); // pad never goes fully empty
        updateTotals();
      });

      lines.push(line);
      rowsHost.appendChild(el);

      if (prefill) {
        line.searchInput.value = prefill.sku;
        if (prefill.qty >= 1) line.qtyInput.value = String(prefill.qty);
      }
      return line;
    }

    // Close any open suggestion list when clicking elsewhere.
    document.addEventListener('click', function (e) {
      lines.forEach(function (line) {
        if (!line.el.contains(e.target)) closeSuggest(line);
      });
    });

    /* ---------- add all to cart (one request) ---------- */

    async function addAllToCart() {
      clearError();
      /* Merge duplicate variant ids: two pad lines for the same variant must
         become ONE items entry, or /cart/add.js can 422 the whole request. */
      var byId = {};
      lines.forEach(function (line) {
        var q = lineQty(line);
        if (line.variant && q >= 1) byId[line.variant.id] = (byId[line.variant.id] || 0) + q;
      });
      var items = Object.keys(byId).map(function (id) {
        return { id: Number(id), quantity: byId[id] };
      });
      if (!items.length) { showError(cfg.errEmpty); return; }

      addAllBtn.disabled = true;
      addAllBtn.setAttribute('aria-busy', 'true');
      try {
        var res = await fetch(routeRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!res.ok) {
          var msg = cfg.errCart;
          try {
            var body = await res.json();
            if (body && (body.description || body.message)) {
              msg = body.description || body.message;
            }
          } catch (ignore) { /* keep default message */ }
          showError(msg);
          return;
        }
        window.location.href = routeRoot() + 'cart';
      } catch (e) {
        showError(cfg.errNetwork);
      } finally {
        addAllBtn.disabled = false;
        addAllBtn.removeAttribute('aria-busy');
      }
    }

    /* ---------- paste a list ---------- */

    async function resolveBySku(line, sku) {
      try {
        var products = await searchProducts(sku);
        for (var i = 0; i < Math.min(products.length, 5); i++) {
          try {
            var product = await fetchProduct(products[i].handle);
            var v = pickVariant(product, sku);
            if (v) {
              line.searchInput.value = sku;
              return await selectProduct(line, products[i].handle, sku);
            }
          } catch (inner) { /* try the next candidate */ }
        }
        setStatus(line, cfg.noMatchFull, 'warn');
        return false;
      } catch (e) {
        setStatus(line, cfg.errNetwork, 'warn');
        return false;
      }
    }

    async function loadPastedList() {
      clearError();
      if (!pasteArea) return;
      var rawLines = pasteArea.value.split('\n')
        .map(function (l) { return l.trim(); })
        .filter(Boolean);
      if (!rawLines.length) { showError(cfg.errPasteEmpty); return; }

      // Reset the pad to exactly the pasted lines.
      lines.slice().forEach(function (line) { line.el.remove(); });
      lines.length = 0;

      var parsed = rawLines.map(function (raw) {
        var parts = raw.split(/[,;\t]+/);
        var sku = (parts[0] || '').trim();
        var qtyRaw = (parts[1] || '').trim();
        var qty = parseInt(qtyRaw, 10);
        /* Missing qty -> default 1. An EXPLICIT 0 or negative means "skip" —
           silently coercing it to 1 would add items the buyer chose to exclude. */
        if (qtyRaw === '') qty = 1;
        return { sku: sku, qty: qty };
      }).filter(function (p) { return p.sku !== '' && !isNaN(p.qty) && p.qty >= 1; });

      if (!parsed.length) {
        createLine(null);
        showError(cfg.errPasteEmpty);
        return;
      }

      if (parseBtn) { parseBtn.disabled = true; parseBtn.setAttribute('aria-busy', 'true'); }
      var missed = [];
      try {
        for (var i = 0; i < parsed.length; i++) {
          var line = createLine(parsed[i]);
          var ok = await resolveBySku(line, parsed[i].sku);
          if (!ok) missed.push(parsed[i].sku);
        }
      } finally {
        if (parseBtn) { parseBtn.disabled = false; parseBtn.removeAttribute('aria-busy'); }
      }
      if (missed.length) showError(cfg.errUnmatched + ' ' + missed.join(', '));
      updateTotals();
    }

    /* ---------- wire up ---------- */

    if (addLineBtn) addLineBtn.addEventListener('click', function () { createLine(null); });
    addAllBtn.addEventListener('click', addAllToCart);
    if (parseBtn) parseBtn.addEventListener('click', loadPastedList);

    createLine(null);
    createLine(null);
    createLine(null);
    updateTotals();
  }

  function initAll() {
    document.querySelectorAll('[data-wnbc-qo]').forEach(initPad);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
